// Hook to fetch the /reports/${reportEndpoint} data

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useRef } from 'react';

export const useFetchReportData = () => {
    const error = useRef(null);
    const foundData = useRef(false);
    const reportData = useRef({});

    const getReportData = useCallback(async ({ params, reportEndpoint, t }) => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        try {
            const response = await axios.get(`/reports/${reportEndpoint}`, {
                cancelToken: source.token,
                params
            });
            if (response.data?.data?.foundReportableData) {
                reportData.current = {
                    ...response.data?.data?.reportData
                };
                foundData.current = true;
            } else {
                reportData.current = {};
                foundData.current = false;
            }
        } catch (err) {
            Notify.error(t('Reports.errorGettingData'));
            debug.e('Error Getting Report Information', err);
            error.current = err;
        }
        return {
            error: error.current,
            foundData: foundData.current,
            reportData: reportData.current
        };
    }, []);

    return { getReportData };
};
